import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './style.scss';

import { timer } from "../../utils/timer";

const defaultTimeObj = { days: '00', hours: '00', minutes: '00' };

export const Timer = ({ unixTime, setTimeIsUp }) => {
    let intervalId = 0;

    const [localUnixTime, setLocalUnixTime] = useState(unixTime);
    const [objTimer, setObjTimer] = useState(defaultTimeObj);

    useEffect(() => {
        intervalId = setInterval(() => {

            if (localUnixTime <= 0) {
                clearInterval(intervalId);
            } else {
                setLocalUnixTime((prevState) => prevState <= 0 ? 0 : prevState-1000); //1000 ms
            }

        }, 1000);

        return () => {
            clearInterval(intervalId);
        };
    }, []);

    useEffect(() => {

        if (localUnixTime === 0) {
            setTimeIsUp(true);
            setObjTimer(defaultTimeObj);
        } else {
            const newObjTimer = timer(localUnixTime);

            setObjTimer(newObjTimer);
        }

    }, [localUnixTime]);

    if (!unixTime) {
        return null;
    }

    return (
        <div className = ' timer'>
            <div className = 'timer__column timer__days '>
                <span className = 'timer__num'>{objTimer.days}</span>
                <span className = 'timer__str'>Днів</span>
            </div>
            <div className = 'timer__column timer__separate timer__hours '>
                <span className = 'timer__num'>{objTimer.hours}</span>
                <span className = 'timer__str'>Годин</span>
            </div>
            <div className = 'timer__column timer__min '>
                <span className = 'timer__num'>{objTimer.minutes}</span>
                <span className = 'timer__str'>Хвилин</span>
            </div>
        </div>
    );
};

Timer.propTypes = {
    unixTime:    PropTypes.number.isRequired,
    setTimeIsUp: PropTypes.func.isRequired,
};
